// src/jsx/components/DeleteReasonModal.jsx
import { Button, Modal, Radio } from "antd";
import React, { useState } from "react";



const DeleteReasonModal = ({ visible, onClose, onConfirm }) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (!reason) return;
    onConfirm(reason);
    setReason("");
  };

  return (
    <Modal
      open={visible}
      title="Seleccione el motivo de la baja"
      onCancel={() => {
        setReason("");
        onClose();
      }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancelar
        </Button>,
        <Button key="confirm" type="primary" onClick={handleConfirm} disabled={!reason}>
          Confirmar
        </Button>,
      ]}
    >
      <Radio.Group onChange={(e) => setReason(e.target.value)} value={reason}>
        <Radio value="Despido Justificado">Despido Justificado</Radio>
        <Radio value="Despido Injustificado">Despido Injustificado</Radio>
        <Radio value="Fin Contrato">Fin Contrato</Radio>
        <Radio value="Renuncia">Renuncia</Radio>
      </Radio.Group>
    </Modal>
  );
};

export default DeleteReasonModal;
